<template>
  <div class="w3-container devicecontainer" v-if="user">
    
    <button v-if="editdevice" @click="clear()"  class="w3-button w3-border w3-round-xxlarge">&#171;&#171;</button>

    <template v-if="devices && !editdevice">
      
 
           <div v-for="(device, deviceKey) in devices" :key="deviceKey"  >

              <div class="w3-round-large w3-block w3-border w3-round-xxlarge w3-display-container" style="height:150px;">

                <span class="w3-display-left" @click="editThisdevice(device)">   
                    <h2 class="w3-padding w3-display-left" >
                        <font color="green"><i class="fa fa-pencil"></i></font>
                    </h2>
                </span> 
                   
                
                <h4 class="w3-padding w3-display-topmiddle"  @click="setSelectedDevice(deviceKey)">                      
                  <font v-if="selecteddevice===deviceKey" color="green">{{device._deviceType}}-{{device.label}}</font>
                  <font v-if="selecteddevice!==deviceKey" color="gray" >{{device._deviceType}}-{{device.label}}</font>
                </h4>           
                <div class="w3-padding w3-display-bottommiddle" v-for="(sim, simKey) in device.sims" :key="simKey">                    
                    <span v-if="sim.default">
                      <div>SIM Number/label:{{sim.phoneNumber}}</div>
                      <div>Carrier:{{sim.carrierName}}</div>
                    </span>
                </div>
                
                <span class="w3-display-right" @click="setSelectedDevice(deviceKey);$router.push('MessagesInbox')">   
                    <h2 class="w3-padding w3-display-right" >
                        <font color="green"><i class="fa fa-envelope-o"></i></font>
                    </h2>
                </span> 

              </div>
              <br>
          </div>               
       
    </template>

    <template v-if="editdevice" class="w3-display-container">      
        <div class="w3-ul w3-panel w3-border w3-round-large devicecontainer"> 
            <p>                       
              
              <div class="w3-row w3-section">
                <!-- <div class="w3-col" style="width:50px">{{editdevice._deviceType}}</div> -->
                <div class="w3-rest">
                  <input type="tel" class="w3-input w3-border" :placeholder="editdevice._deviceType + ' Friendly label'" style="resize:none" v-model="editdevice.label"/>
                </div>
              </div>                    
              

              <div v-for="(sim, simKey) in editdevice.sims" :key="simKey" class="w3-button w3-block w3-border w3-round-xxlarge w3-display-container">          
                <span>
                    <div class="w3-row-padding">
                      <div class="w3-half">
                        <label>SIM ID</label>
                        {{sim.deviceId}}
                      </div>
                      <div class="w3-half">
                        <label>Carrier</label>
                        {{sim.carrierName}}
                      </div>
                    </div>
                    
                    <span>                    
                      <div class="w3-row w3-section">
                        <div class="w3-col" style="width:50px"><i class="w3-xlarge fa fa-phone"></i></div>
                          <div class="w3-rest">
                            <input class="w3-input w3-border" :name="sim.deviceId" type="text" placeholder="SIM Number" v-model="sim.phoneNumber">
                          </div>
                      </div>                    
                    </span> 

                  

                  <span class="w3-display-topright">                                    
                      <h2 class="w3-padding" @click="setSelectedSim(simKey)">                      
                        <font v-if="sim.default"  color="green"><i class="fa fa-check"></i></font>
                        <font v-if="!sim.default" color="gray" ><i class="fa fa-check"></i></font>
                      </h2>
                  </span>
                </span>
                
              </div>                             
            <br>
            <button @click="saveDeviceInfo(devices);" class="w3-button w3-border w3-round-xxlarge">Save</button>
         
            
        </div>
    </template>


  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  name: "Devices",
  data() {
    return {
      editdevice: null,
      msg: "Welcome to the Devices page",
      
    };
  },
  beforeCreated() {},
  created: function() {},
  mounted() {},
  methods: {
    setSelectedSim(selectedsimKey){
        let sims = this.devices[this.editdevice._uuid].sims
        Object.keys(sims).forEach((simkey)=>{            
            sims[simkey].default = (simkey===selectedsimKey)
        }) 
        this.editdevice.sims[selectedsimKey].default=true       
    },
    editThisdevice(device){
        this.editdevice = device;
    },
    clear() {
      this.editdevice = null;
    },   
    ...mapActions(["setSelectedDevice","saveDeviceInfo"])
  },
  computed: {
    ...mapGetters(["user", "devices","selecteddevice"])
  },
  beforeDestroy() {},
  destroy() {
    this.editdevice = null
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.devicecontainer {
  padding-top: 10px;
  padding-bottom: 10px;
}


.w3-ul li {
  border-bottom: none;
}

.footer {
  padding-top: 10px;
}
/* ============================================================================================================================
== BUBBLE WITH AN ISOCELES TRIANGLE
** ============================================================================================================================ */

/* THE SPEECH BUBBLE
------------------------------------------------------------------------------------------------------------------------------- */

.triangle-isosceles {
  position: relative;
  padding: 15px;
  margin: 1em 0 3em;
  color: #000;
  background: #f3961c; /* default background for browsers without gradient support */
  /* css3 */
  background: -webkit-gradient(linear, 0 0, 0 100%, from(#f9d835), to(#f3961c));
  background: -moz-linear-gradient(#f9d835, #f3961c);
  background: -o-linear-gradient(#f9d835, #f3961c);
  background: linear-gradient(#f9d835, #f3961c);
  -webkit-border-radius: 10px;
  -moz-border-radius: 10px;
  border-radius: 10px;
}

/* Variant : for top positioned triangle
------------------------------------------ */

.triangle-isosceles.top {
  background: -webkit-gradient(linear, 0 0, 0 100%, from(#f3961c), to(#f9d835));
  background: -moz-linear-gradient(#f3961c, #f9d835);
  background: -o-linear-gradient(#f3961c, #f9d835);
  background: linear-gradient(#f3961c, #f9d835);
}

/* Variant : for left/right positioned triangle
------------------------------------------ */

.triangle-isosceles.left {
  margin-right: 100px;
  margin-left: 50px;
  background: #f3961c;
}

/* Variant : for right positioned triangle
------------------------------------------ */

.triangle-isosceles.right {
  margin-right: 50px;
  margin-left: 100px;
  background: greenyellow;
}

/* THE TRIANGLE
------------------------------------------------------------------------------------------------------------------------------- */

/* creates triangle */
.triangle-isosceles:after {
  content: "";
  position: absolute;
  bottom: -15px; /* value = - border-top-width - border-bottom-width */
  left: 50px; /* controls horizontal position */
  border-width: 15px 15px 0; /* vary these values to change the angle of the vertex */
  border-style: solid;
  border-color: #f3961c transparent;
  /* reduce the damage in FF3.0 */
  display: block;
  width: 0;
}

/* Variant : top
------------------------------------------ */

.triangle-isosceles.top:after {
  top: -15px; /* value = - border-top-width - border-bottom-width */
  right: 50px; /* controls horizontal position */
  bottom: auto;
  left: auto;
  border-width: 0 15px 15px; /* vary these values to change the angle of the vertex */
  border-color: #f3961c transparent;
}

/* Variant : left
------------------------------------------ */

.triangle-isosceles.left:after {
  top: 16px; /* controls vertical position */
  left: -50px; /* value = - border-left-width - border-right-width */
  bottom: auto;
  border-width: 10px 50px 10px 0;
  border-color: transparent #f3961c;
}

/* Variant : right
------------------------------------------ */

.triangle-isosceles.right:after {
  top: 16px; /* controls vertical position */
  right: -50px; /* value = - border-left-width - border-right-width */
  bottom: auto;
  left: auto;
  border-width: 10px 0 10px 50px;
  border-color: transparent greenyellow;
}
</style>



// WEBPACK FOOTER //
// src/components/Devices.vue